import { render, staticRenderFns } from "./Jadwal.vue?vue&type=template&id=0c27f3b0&scoped=true"
import script from "./Jadwal.vue?vue&type=script&lang=js"
export * from "./Jadwal.vue?vue&type=script&lang=js"
import style0 from "./Jadwal.vue?vue&type=style&index=0&id=0c27f3b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c27f3b0",
  null
  
)

export default component.exports